import React, { Fragment } from 'react'
import actions from 'redux/actions'
import { useConnect } from 'sb-redux-hook'
import { constants, snowplow } from 'common/helpers'
import { injectIntl, FormattedMessage } from 'sb-react-intl'
import cx from 'classnames'

import SidebarNav from './SidebarNav/SidebarNav'

import messages from './messages'
import s from './HamburgerButton.scss'


const HamburgerButton = ({ intl, className }) => {
  const { userLoggedIn } = useConnect({
    userLoggedIn: 'models.me.isLoggedIn',
  })

  return (
    <Fragment>
      <button
        className={cx(s.button, className)}
        aria-label={intl.formatMessage(messages.mainMenu)}
        type="button"
        onClick={() => {
          actions.models.ui.openSideMenu()
          snowplow.track(constants.snowplowEvents.burgerMenuClick, {
            userLoggedIn: userLoggedIn ? 'yes' : 'no',
          })
        }}
      >
        <div className={s.container}>
          <div className={s.icon}>
            <FormattedMessage className={s.menuLabel} tag="div" {...messages.menu} />
          </div>
        </div>
      </button>
      <SidebarNav />
    </Fragment>
  )
}


export default injectIntl(HamburgerButton)
